// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"91d0000e","455":"ae3fcceb","977":"c63f6181"}[chunkId] + ".chunk.js";
};